/** Central registry of real project assets — Provident Winworth Edappally, Kochi. */

export const ASSETS = {
  // Brand
  logo: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/msbsnbyo_logo.png",
  puravankaraLogo: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/kejco62y_Provident_logo_final_blacks.png",

  // Elevation renders (artistic impressions)
  elevation1: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/cr99qck2_Winworth_1920px-x-600px.jpg",
  elevation2: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/0a2rht9v_Winworth_1920px-x-600px001ww.jpg",

  // Location walk-through videos
  video1: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/vudv44tt_purvankara%20kochi%20video%20edappally1.mp4",
  video2: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/onlfwqbp_purvankara%20kochi%20video%20edappally2.mp4",

  // Amenities photography
  amenityKalary: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/jbgkbbr0_provident%20winworth%20kochi%20%28cochin%29%20amenities%20kalary.jpg",
  amenityInternal: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/68yqg7kj_provident%20winworth%20kochi%20%28cochin%29%20amenities%20internal.jpg",
  amenity4: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/twj5mlt4_provident%20winworth%20kochi%20%28cochin%29%20amenities%204.jpg",

  // NEW: brochure grids & branded assets
  masterPlan: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/yt2n29t3_WhatsApp%20Image%202026-07-02%20at%209.45.10%20PM%20%2811%29.jpeg",
  locationMap: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/33tqjgea_WhatsApp%20Image%202026-07-02%20at%209.45.10%20PM%20%2810%29.jpeg",
  amenityGridSports: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/83gstevz_WhatsApp%20Image%202026-07-02%20at%209.45.10%20PM%20%289%29.jpeg",
  amenityGridLifestyle: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/4rgg3i0g_WhatsApp%20Image%202026-07-02%20at%209.45.10%20PM%20%286%29.jpeg",

  // Brochures
  brochureMain: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/6xx42yt6_Provident%20Winworth%20Brochure.pdf",
  brochure2024: "https://customer-assets.emergentagent.com/job_purva-flagship-kochi/artifacts/h86nm5fy_Provident%20Winworth%20Brochure%202024.pdf",
};

export const GALLERY_IMAGES = [
  { src: ASSETS.elevation1, cat: "Elevation", alt: "Provident Winworth aerial elevation dusk view" },
  { src: ASSETS.elevation2, cat: "Elevation", alt: "Provident Winworth twin tower composition" },
  { src: ASSETS.amenityInternal, cat: "Amenities", alt: "Provident Winworth internal amenities" },
  { src: ASSETS.amenityKalary, cat: "Amenities", alt: "Kalari court fitness with regional twist" },
  { src: ASSETS.amenity4, cat: "Amenities", alt: "Community amenity zones" },
];
